import { FC } from 'react';

export const DropdownChevronIcon: FC = () => (
  <svg viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /* eslint-disable-next-line max-len */
      d="M7.97686 9.74983L13.4036 4.31946C13.4693 4.23179 13.5013 4.12335 13.4935 4.01404C13.4857 3.90472 13.4388 3.80188 13.3613 3.72439C13.2838 3.6469 13.181 3.59997 13.0716 3.5922C12.9623 3.58443 12.8539 3.61635 12.7662 3.6821L7.65544 8.79287L2.54467 3.6821C2.50554 3.62992 2.45565 3.58676 2.39838 3.55554C2.34111 3.52432 2.2778 3.50577 2.21274 3.50115C2.14768 3.49652 2.08238 3.50593 2.02127 3.52874C1.96016 3.55155 1.90467 3.58722 1.85855 3.63334C1.81242 3.67946 1.77675 3.73495 1.75394 3.79606C1.73113 3.85717 1.72172 3.92247 1.72635 3.98753C1.73097 4.05259 1.74952 4.1159 1.78074 4.17317C1.81196 4.23044 1.85513 4.28033 1.90731 4.31946L7.33767 9.74983C7.42285 9.83379 7.53765 9.88087 7.65726 9.88087C7.77687 9.88087 7.89167 9.83379 7.97686 9.74983Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.780449"
    />
  </svg>
);
